import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ReturnReasonModel } from '@app/models';

@Injectable({
    providedIn: 'root',
})
export class ReturnReasonService
{
    private endPoint = '/returnReasons';
    private http = inject(HttpClient);

    getReturnReasons(): Promise<ReturnReasonModel[]>
    {
        return firstValueFrom(this.http.get<ReturnReasonModel[]>(this.endPoint));
    }
}
